import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
    Container
} from 'react-bootstrap'
import "./styles/vendors-styles.scss"
import VendorsTableTopBar from './includes/VendorsTable/VendorsTableTopBar'
import VendorsTable from './includes/VendorsTable/VendorsTable'
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'
import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import useQuery from 'utlis/CustomHooks/useQueryHook'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    VENDOR_DELETED_SUCCESSFULLY,
    ERROR_WHILE_DELETING_VENDORS,
    ERROR_WHILE_FETCHING_VENDORS
} from 'utlis/AppMessages/AppMessages'
import { CONFIRMATION_BEFORE_DELETING_VENDOR } from 'utlis/AppMessages/AppMessages'
import { deleteVendor, getVendors } from 'utlis/Apis/Vendor_API'
import { toast } from 'react-toastify'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function Vendors(props) {
    // props
    const { authState } = props

    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    // store url
    const [storeUrl] = useStoreUrl()

    const [vendors, setVendors] = useState([])
    const [loading, setLoading] = useState(false)

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [paginationLinks, setPaginationLinks] = useState([])

    const [column__vendorName, setColumn__vendorName] = useState(true)
    const [column__companyName, setColumn__companyName] = useState(true)
    const [column__email, setColumn__email] = useState(true)
    const [column__phone, setColumn__phone] = useState(true)
    const [column__businessLicenceNumber, setColumn__businessLicenceNumber] = useState(true)
    const [column__status, setColumn__status] = useState(true)

    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)

    const [searchQuery, setSearchQuery] = useState("")

    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    useEffect(() => {
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setSectionLoadingVisible(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getVendors(headers, URLParams).then(res => {
            setSectionLoadingVisible(false)
            setLoading(false)

            const resData = res.data

            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setVendors(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();

                toast.error(ERROR_WHILE_FETCHING_VENDORS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getVendors `, err.message)

            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [keyword, page, props])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);
    };

    const handleDelete = (ev, vendor_id) => {
        ev.preventDefault()

        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_VENDOR)

        if (confirmation) {
            setSectionLoadingVisible(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            deleteVendor(headers, vendor_id).then(res => {

                setSectionLoadingVisible(false)

                const deletedData = res.data
                if (deletedData.success) {
                    const filtersVendorList = vendors.filter(item => item.vendor_id !== vendor_id)

                    setVendors(filtersVendorList)

                    toast.dismiss();
                    toast.success(VENDOR_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_VENDORS, res)
                    toast.dismiss();

                    toast.error(ERROR_WHILE_DELETING_VENDORS, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteVendor `, err.message)

                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }

    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        setSectionLoadingVisible(true)
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`${storeUrl}/vendors?keyword=${searchQueryValue}&page=1`)
        }
        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`${storeUrl}/vendors?page=1`)
        }
    }, 500)

    return (
        <section id="app-vendors" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-vendors">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Vendors</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <VendorsTableTopBar
                                        column__vendorName={column__vendorName}
                                        column__companyName={column__companyName}
                                        column__email={column__email}
                                        column__phone={column__phone}
                                        column__businessLicenceNumber={column__businessLicenceNumber}
                                        column__status={column__status}

                                        setColumn__vendorName={setColumn__vendorName}
                                        setColumn__companyName={setColumn__companyName}
                                        setColumn__email={setColumn__email}
                                        setColumn__phone={setColumn__phone}
                                        setColumn__businessLicenceNumber={setColumn__businessLicenceNumber}
                                        setColumn__status={setColumn__status}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table vendors-table">
                                    <VendorsTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}

                                        column__vendorName={column__vendorName}
                                        column__companyName={column__companyName}
                                        column__email={column__email}
                                        column__phone={column__phone}
                                        column__businessLicenceNumber={column__businessLicenceNumber}
                                        column__status={column__status}

                                        loadingCount={loadingCount}
                                        loading={loading}

                                        vendors={vendors}

                                        handleDelete={(ev, vendor_id) => handleDelete(ev, vendor_id)}
                                    />

                                    {
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={storeUrl + "/catalog/vendors"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         functionsData: (prop) => dispatch(functionsData(prop)),
//     }
// }

export default connect(getDataFromStore, null)(Vendors)